import Vue from 'vue';
import alice from '../../alice-api';

export default {
  namespaced: true,
  state: {
    benchmarkList: [],
    benchmarkTestData: {},
    benchmarkResultPageData: {},
    baselineResultPageData: {},
    benchmarkRawResultPageData: {},
  },
  getters: {
    benchmarkList: (state) => state.benchmarkList,
    benchmarkResultPageData: (state) => state.benchmarkResultPageData,
    benchmarkRawResultPageData: (state) => state.benchmarkRawResultPageData,
    baselineResultPageData: (state) => state.baselineResultPageData,
  },
  actions: {
    loadBenchmarkList(context) {
      return new Promise((resolve, reject) => {
        alice
          .listBenchmark()
          .then((response) => {
            context.commit('setBenchmarkList', response.data.data);
            resolve(response.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    testBenchmark(context, { benchmarkId, testSetId }) {
      return new Promise((resolve, reject) => {
        alice
          .testBenchmark(benchmarkId, testSetId)
          .then((response) => {
            context.commit('setBenchmarkTestData', response.data.data);
            resolve(response.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    loadBenchmarkResultPage(context, { benchmarkId, page, size }) {
      return new Promise((resolve, reject) => {
        alice
          .getBenchmarkResultPage(benchmarkId, page, size, '')
          .then((response) => {
            context.commit('setBenchmarkResultPageData', response.data.data);
            resolve(response.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    loadBaselineResultPage(context, { benchmarkId, page, size }) {
      return new Promise((resolve, reject) => {
        alice
          .getBenchmarkResultPage(benchmarkId, page, size, true)
          .then((response) => {
            context.commit('setBaselineResultPageData', response.data.data);
            resolve(response.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    loadBenchmarkRawResultPage(context, {
      benchmarkId, testId, page, size, filterData,
    }) {
      return new Promise((resolve, reject) => {
        alice
          .getBenchmarkRawResultPage(benchmarkId, testId, page, size, filterData)
          .then((response) => {
            context.commit('setBenchmarkRawResultPageData', response.data.data);
            resolve(response.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    setBenchmarkTestResultBaseline(context, { benchmarkId, testId }) {
      return new Promise((resolve, reject) => {
        alice
          .setBenchmarkTestResultBaseline(benchmarkId, testId)
          .then((response) => {
            resolve(response.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
  mutations: {
    setBenchmarkList(state, data) {
      Vue.set(state, 'benchmarkList', data);
    },
    setBenchmarkTestData(state, data) {
      Vue.set(state, 'benchmarkTestData', data);
    },
    setBenchmarkResultPageData(state, data) {
      Vue.set(state, 'benchmarkResultPageData', data);
    },
    setBaselineResultPageData(state, data) {
      Vue.set(state, 'baselineResultPageData', data);
    },
    setBenchmarkRawResultPageData(state, data) {
      Vue.set(state, 'benchmarkRawResultPageData', data);
    },
  },
};
